/**
 * O que o Lume deixa dito ao header do site.
 *
 * A pill e o card do drawer têm um estado de regresso — "Continuar no Lume" —
 * que depende de o aluno já ter um caderno. Essa pergunta é por aluno e o
 * header vive em páginas cacheadas pelo Varnish, por isso não pode ser
 * respondida em PHP; e um fetch a /api/lume/caderno em cada página do site
 * pagaria uma viagem para decidir uma label.
 *
 * Então o Lume escreve aqui o que já sabe, e o header lê. O leitor é o script
 * inline em views/partials/header-nav-scripts.php — mudar a chave obriga a
 * mudá-la lá.
 *
 * Só um sim/não: nada de nomes, progresso ou ids. O selo é uma dica de
 * navegação, não uma cache de dados — quem quer os dados pede-os à API.
 */
const KEY = "lume.hasCaderno";

/** Chamado por quem acaba de saber a resposta: o Início e a criação. */
export function stampHasCaderno(hasCaderno: boolean): void {
  try {
    window.localStorage.setItem(KEY, hasCaderno ? "1" : "0");
  } catch {
    // Store bloqueado (modo privado, cookies de terceiros): o header fica no
    // estado "novo", que é o seguro. Não vale um erro.
  }
}

/** No logout: o próximo aluno neste browser não herda o caderno do anterior. */
export function clearCadernoStamp(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // idem
  }
}
